import "../App.css";
import basket from "../images/basket.png";
import corn from "../images/corn.png";
import {
  tutorial0Maya1,
  tutorial0Maya2,
  tutorialButtonNextPage,
  tutorialButtonPreviousPage,
  tutorialButtonStartLevel,
  tutorialTitle
} from "../strings";

function Tutorial0Maya({ finishTutorial, page, handleNext, handlePrevious }) {

  const maxPages = 2; // Note that the first page has index 0. This means maxPages-1 is the last page.
  const itemSize = 7;

  const gridCellStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div>
      <div className="tutorial-title">
        {tutorialTitle}
      </div>
      <div className="tutorial-body">
        {page === 0 && 
          <div>
            {tutorial0Maya1}
          </div>
        }
        {page === 1 && 
          <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%"}}>
            {tutorial0Maya2}
            <br></br>&nbsp;<br></br>
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gridTemplateRows: 'auto auto', width: "90%", rowGap: "2dvh"}}>
              <div style={gridCellStyle}><img src={corn} alt="maya-image" style={{width: itemSize+"dvh", height: itemSize+"dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/></div>
              <div style={gridCellStyle}>=</div>
              <div style={gridCellStyle}>1</div>
              <div style={gridCellStyle}><img src={basket} alt="maya-image" style={{width: 4*itemSize+"dvh", height: itemSize+"dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/></div>
              <div style={gridCellStyle}>=</div>
              <div style={gridCellStyle}>{Array.from({length: 5}).map(() => (<img alt="maya" src={corn} style={{width: itemSize+"dvh", height: itemSize+"dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/>))}</div>
            </div>
          </div>
        }
      </div>

      {/* Button to start level. */}
      {page === (maxPages-1) && 
        <button
        onClick={finishTutorial}
          className="tutorial-next-button"
        >
        {tutorialButtonStartLevel}
        </button>
      }

      {/* Button to go to previous page. */}
      {page > 0 && 
        <button
          onClick={handlePrevious}
          className="tutorial-previous-button"
        >
        {tutorialButtonPreviousPage}
        </button>
      }

      {/* Button to go to next page. */}
      {page < (maxPages-1) && 
        <button
          onClick={handleNext}
          className="tutorial-next-button"
        >
        {tutorialButtonNextPage}
        </button>
      }
    </div>
  );
}

export default Tutorial0Maya;
